import { useEffect, useState } from 'react';

import { MobileMenuComponentType } from '@core/types';

import { useAppSelector } from '@online-webinar/store';
import { useTranslation } from 'react-i18next';
import { IconChapters, IconChat, IconPolls, IconSlides } from '../MobileMenu/atoms';
import { MenuItemProps } from '../MobileMenu/molecules/MenuItem/types';
import { MobileMenu } from '../MobileMenu/organisms';
import { MobileMenuNavigatorProps } from './types';

export const MobileMenuNavigatorBroadcaster = ({ onItemClick }: MobileMenuNavigatorProps) => {
    const { t } = useTranslation();
    const [activeMenuItem, setActiveMenuItem] = useState<MobileMenuComponentType>(MobileMenuComponentType.SLIDES);
    const [slideIndicatorActive, setSlideIndicatorActive] = useState<boolean>(false);

    const activeSlideNumber = useAppSelector((state) => state.liveWebinar.activeSlideNumber);

    const menuItemClick = (type: MobileMenuComponentType): void => {
        setActiveMenuItem(type);
        onItemClick(type);
        if (type === MobileMenuComponentType.SLIDES) {
            setSlideIndicatorActive(false);
        }
    };

    const menuItemsData: MenuItemProps[] = [
        {
            label: 'Chat',
            componentType: MobileMenuComponentType.CHAT,
            onItemClick: menuItemClick,
            active: activeMenuItem === MobileMenuComponentType.CHAT,
            indicatorActive: false,
            icon: <IconChat />
        },
        {
            label: 'Chapters',
            componentType: MobileMenuComponentType.CHAPTER,
            onItemClick: menuItemClick,
            active: activeMenuItem === MobileMenuComponentType.CHAPTER,
            indicatorActive: false,
            icon: <IconChapters />
        },
        {
            label: 'Slides',
            componentType: MobileMenuComponentType.SLIDES,
            onItemClick: menuItemClick,
            active: activeMenuItem === MobileMenuComponentType.SLIDES,
            indicatorActive: slideIndicatorActive,
            indicatorLabel: t('Player.Menu.NewSlide'),
            icon: <IconSlides />
        },
        {
            label: 'Participants',
            componentType: MobileMenuComponentType.PARTICIPANTS,
            onItemClick: menuItemClick,
            active: activeMenuItem === MobileMenuComponentType.PARTICIPANTS,
            indicatorActive: false,
            icon: <IconPolls />
        },
        {
            label: 'Polls',
            componentType: MobileMenuComponentType.POLLS,
            onItemClick: menuItemClick,
            active: activeMenuItem === MobileMenuComponentType.POLLS,
            indicatorActive: false,
            icon: <IconPolls />
        }
    ];

    useEffect(() => {
        if (activeMenuItem !== MobileMenuComponentType.SLIDES) {
            const hasSlides = menuItemsData.some((item) => item.componentType === MobileMenuComponentType.SLIDES);
            if (hasSlides) {
                setSlideIndicatorActive(true);
            }
        }
    }, [activeSlideNumber]);

    return <MobileMenu menuItems={menuItemsData} />;
};
